import { makeStyles } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { updateTitle } from '../reducers/header';

const useStyles = makeStyles({
  container: {
    margin: 20,
  },
});

function UnauthorizedPage() {
  const classes = useStyles();
  const dispatch = useDispatch()
  React.useEffect(() => {
    dispatch(updateTitle({
      subtitle: 'Forbidden',
      title: '403',
    }))
  }, [dispatch])
  return (
    <div className={classes.container}>
      You don't have permission to access that page.
    </div>
  )
}

export default UnauthorizedPage